export default {
    mapboxToken: 'pk.eyJ1IjoiYmVydHJhbmRkZWx2YXV4IiwiYSI6ImNrdGpxNndubTA1MGMycW55MHdkbHV1bjQifQ.oABcqbGoOCY0hYQu8WOZqw',
};